import * as ReactDOM from 'react-dom/client';
import registerServiceWorker, { registerSharedWorker }  from './serviceWorkerRegistration';
import { environment } from './environments/environment';

import App from './app/app';
import { initializeWebView } from '@nxplatform/spa-service/hooks';
import { attachProvisionalGlobalHandlers, loadSentry, makeReactErrorHandler } from '@nxplatform/helpers/sentry/sentry';


const agent = window.navigator?.userAgent || '';
const { turnOnWebView: isWebView } = initializeWebView();
// eslint-disable-next-line sonarjs/prefer-regexp-exec
const navigatorSpeedTest = agent.match(/(Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0.0.0 Mobile Safari\/537\.36)|(Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Safari\/537\.36)|(Speed Insights)|(Chrome-Lighthouse)|(PSTS[\d\.]+)/);

const sampleRate = navigatorSpeedTest
|| agent === 'Mozilla/5.0 (Linux; Android 11; moto g power (2022)) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/119.0.0.0 Mobile Safari/537.36'
|| agent === 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/119.0.0.0 Safari/537.36'
  ? 1.0 : 0;

if (sampleRate === 1.0 || window.isPrerender) {
  // @ts-ignore
  window.isBot = true;
}

const initSentry = () => {
  if (environment.production && !window.isPrerender && environment.sentryKey) {
    loadSentry(environment);
  }
};

attachProvisionalGlobalHandlers(initSentry);

const errorHandlers = {
  onUncaughtError: makeReactErrorHandler(),
  onCaughtError: makeReactErrorHandler(),
  onRecoverableError: makeReactErrorHandler(),
};

const root = ReactDOM.createRoot(
  document.getElementById('platform') as HTMLElement,
  { ...errorHandlers },
);
root.render(
  <App />
);

if (environment.production) {
  registerServiceWorker();
  registerSharedWorker();
}
